/**
 * @generated SignedSource<<de4b73143d686e27a49b9b35a206a575>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueHistoryFragment$data = {
  readonly history: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly actor: {
          readonly accountId: string;
          readonly name: string;
          readonly picture: AGG$URL;
        } | null | undefined;
        readonly fieldDisplayName: string | null | undefined;
        readonly fieldId: string | null | undefined;
        readonly fieldSchema: {
          readonly customFieldType: string | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly fieldType: string | null | undefined;
        readonly from: {
          readonly absoluteIconUrl?: string | null | undefined;
          readonly avatarUrl?: string | null | undefined;
          readonly categoryId?: AGG$Long | null | undefined;
          readonly displayValue?: string | null | undefined;
          readonly formattedValue?: string | null | undefined;
          readonly iconUrl?: string | null | undefined;
          readonly responders?: ReadonlyArray<{
            readonly ari: string | null | undefined;
            readonly avatarUrl: string | null | undefined;
            readonly name: string | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly value?: string | null | undefined;
          readonly worklog?: {
            readonly id: string;
            readonly timeSpent: {
              readonly timeInSeconds: AGG$Long | null | undefined;
            } | null | undefined;
            readonly workDescription: {
              readonly adfValue: {
                readonly convertedPlainText: {
                  readonly plainText: string | null | undefined;
                } | null | undefined;
                readonly json: AGG$JSON | null | undefined;
              } | null | undefined;
            } | null | undefined;
            readonly worklogId: string;
          } | null | undefined;
        } | null | undefined;
        readonly i18nDescription: string | null | undefined;
        readonly id: string;
        readonly isDueToRedaction: boolean | null | undefined;
        readonly isDueToRedactionRestore: boolean | null | undefined;
        readonly timestamp: AGG$Long | null | undefined;
        readonly to: {
          readonly absoluteIconUrl?: string | null | undefined;
          readonly avatarUrl?: string | null | undefined;
          readonly categoryId?: AGG$Long | null | undefined;
          readonly displayValue?: string | null | undefined;
          readonly formattedValue?: string | null | undefined;
          readonly iconUrl?: string | null | undefined;
          readonly responders?: ReadonlyArray<{
            readonly ari: string | null | undefined;
            readonly avatarUrl: string | null | undefined;
            readonly name: string | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly value?: string | null | undefined;
          readonly worklog?: {
            readonly id: string;
            readonly timeSpent: {
              readonly timeInSeconds: AGG$Long | null | undefined;
            } | null | undefined;
            readonly workDescription: {
              readonly adfValue: {
                readonly convertedPlainText: {
                  readonly plainText: string | null | undefined;
                } | null | undefined;
                readonly json: AGG$JSON | null | undefined;
              } | null | undefined;
            } | null | undefined;
            readonly worklogId: string;
          } | null | undefined;
        } | null | undefined;
      };
    }>;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "IssueHistoryFragment";
};
export type IssueHistoryFragment$key = {
  readonly " $data"?: IssueHistoryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueHistoryFragment">;
};

import IssueHistory_RefetchQuery_graphql from './IssueHistory_RefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "history"
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "type"
},
v3 = {
  "kind": "ScalarField",
  "name": "formattedValue"
},
v4 = {
  "kind": "ScalarField",
  "name": "displayValue"
},
v5 = {
  "kind": "ScalarField",
  "name": "value"
},
v6 = {
  "kind": "ScalarField",
  "name": "avatarUrl"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "categoryId"
      },
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "type": "JiraHistoryStatusFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "concreteType": "JiraWorklog",
        "kind": "LinkedField",
        "name": "worklog",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "worklogId"
          },
          {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "timeSpent",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "timeInSeconds"
              }
            ]
          },
          {
            "concreteType": "JiraRichText",
            "kind": "LinkedField",
            "name": "workDescription",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraADF",
                "kind": "LinkedField",
                "name": "adfValue",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "json"
                  },
                  {
                    "concreteType": "JiraAdfToConvertedPlainText",
                    "kind": "LinkedField",
                    "name": "convertedPlainText",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "plainText"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "JiraHistoryWorkLogFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/)
    ],
    "type": "JiraHistoryAssigneeFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v5/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "iconUrl"
      },
      {
        "kind": "ScalarField",
        "name": "absoluteIconUrl"
      }
    ],
    "type": "JiraHistoryPriorityFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "concreteType": "JiraHistoryResponder",
        "kind": "LinkedField",
        "name": "responders",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "ari"
          },
          (v7/*: any*/),
          (v2/*: any*/),
          (v6/*: any*/)
        ]
      }
    ],
    "type": "JiraHistoryRespondersFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "type": "JiraHistoryGenericFieldValue"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "before"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "last"
    },
    {
      "kind": "RootArgument",
      "name": "orderBy"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "bidirectional",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": {
          "count": "last",
          "cursor": "before"
        },
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": IssueHistory_RefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "IssueHistoryFragment",
  "selections": [
    {
      "alias": "history",
      "args": [
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        }
      ],
      "concreteType": "JiraIssueHistoryConnection",
      "kind": "LinkedField",
      "name": "__IssueHistory_history_connection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueHistoryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraHistoryActivityFeedItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "i18nDescription"
                },
                {
                  "kind": "ScalarField",
                  "name": "fieldDisplayName"
                },
                {
                  "kind": "ScalarField",
                  "name": "fieldId"
                },
                {
                  "kind": "ScalarField",
                  "name": "fieldType"
                },
                {
                  "kind": "ScalarField",
                  "name": "timestamp"
                },
                {
                  "concreteType": "JiraHistoryFieldSchema",
                  "kind": "LinkedField",
                  "name": "fieldSchema",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "customFieldType"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "isDueToRedaction"
                },
                {
                  "kind": "ScalarField",
                  "name": "isDueToRedactionRestore"
                },
                {
                  "kind": "LinkedField",
                  "name": "from",
                  "plural": false,
                  "selections": (v8/*: any*/)
                },
                {
                  "kind": "LinkedField",
                  "name": "to",
                  "plural": false,
                  "selections": (v8/*: any*/)
                },
                {
                  "kind": "LinkedField",
                  "name": "actor",
                  "plural": false,
                  "selections": [
                    (v7/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "accountId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "picture"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "__typename"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "cursor"
            }
          ]
        },
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            },
            {
              "kind": "ScalarField",
              "name": "hasPreviousPage"
            },
            {
              "kind": "ScalarField",
              "name": "endCursor"
            },
            {
              "kind": "ScalarField",
              "name": "startCursor"
            }
          ]
        }
      ]
    },
    (v1/*: any*/)
  ],
  "type": "JiraIssue"
};
})();

(node as any).hash = "ee576f8f8aa6ff147c359258d1d2457b";

export default node;
